/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '@frontend/vimeo';

const body = `<h4>Edit model at Section View</h4>

<p>Edit your model while in Sectional View, or return to the “Setting Section Planes” mode.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('652951824')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export function ToggleClippingEditTooltip() {
    return h('div', { innerHTML: body });
}
